import script from "./CustomMark.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomMark.vue?vue&type=script&lang=ts&setup=true"

import "./CustomMark.vue?vue&type=style&index=0&id=dccc76d2&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dccc76d2"]])

export default __exports__